import { useEffect, useState } from 'react';
const CND_AVAILABILITY_EVENT = 'ibk:cnd-availability-changed';
export function useCndMenuAvailability() {
    const [isAvailable, setIsAvailable] = useState(true);
    useEffect(() => {
        const handleAvailabilityChanged = (event) => {
            const { detail } = event;
            setIsAvailable(detail?.isAvailable ?? true);
        };
        globalThis.addEventListener(CND_AVAILABILITY_EVENT, handleAvailabilityChanged);
        return () => globalThis.removeEventListener(CND_AVAILABILITY_EVENT, handleAvailabilityChanged);
    }, []);
    return isAvailable;
}
